import React from 'react'
import { Tooltip } from 'antd'
import './index.less'

const Index = ()=>{
  return (
    <Tooltip overlayClassName="float-tel-tooltip" placement="left" title='4009318294' arrowPointAtCenter={true} getPopupContainer={() => document.querySelector('.float-tel') as HTMLElement}>
      <div id="floatLel" className="float-tel">
        <span className="float-tel-icon"></span>
        <span className="float-tel-name">电话客服</span>
      </div>
    </Tooltip>
   
  )
}

export default Index;